import { useState } from 'react';
import { ActionIcon, Group, Stack, Text, TextInput } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { SelectedChip, SuggestionChip, SuggestionsLabel } from '../components/WizardChips';

function normalize(value) {
  return String(value || '').trim().toLowerCase();
}

export default function OpenListScreen({ question, value = [], onChange, hideHeader = false }) {
  const [draft, setDraft] = useState('');
  const entries = Array.isArray(value) ? value : [];

  function addEntry(raw) {
    const trimmed = String(raw || '').trim();
    if (!trimmed) return;
    const key = normalize(trimmed);
    if (entries.some((item) => normalize(item) === key)) {
      setDraft('');
      return;
    }
    onChange([...entries, trimmed]);
    setDraft('');
  }

  function removeEntry(index) {
    onChange(entries.filter((_, i) => i !== index));
  }

  const usedExamples = new Set(entries.map(normalize));

  return (
    <Stack gap="lg">
      {!hideHeader && (
        <div>
          <Text fw={700} size="xl" style={{ color: 'var(--aviary-ink)', fontSize: 26, lineHeight: 1.3 }}>
            {question.ask}
          </Text>
          {question.sub && (
            <Text size="sm" mt={6} style={{ color: 'var(--aviary-muted)', lineHeight: 1.45 }}>
              {question.sub}
            </Text>
          )}
        </div>
      )}

      <Group gap="xs" align="flex-end" wrap="nowrap">
        <TextInput
          style={{ flex: 1 }}
          placeholder={question.placeholder || ''}
          value={draft}
          onChange={(e) => setDraft(e.currentTarget.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              addEntry(draft);
            }
          }}
          size="md"
        />
        <ActionIcon
          size={42}
          color="sage"
          variant="filled"
          onClick={() => addEntry(draft)}
          aria-label="Add"
        >
          <IconPlus size={20} />
        </ActionIcon>
      </Group>

      {entries.length > 0 && (
        <Group gap="xs">
          {entries.map((entry, index) => (
            <SelectedChip
              key={`${normalize(entry)}-${index}`}
              label={entry}
              onRemove={() => removeEntry(index)}
            />
          ))}
        </Group>
      )}

      {Array.isArray(question.examples) && question.examples.length > 0 && (
        <Stack gap="xs">
          <SuggestionsLabel />
          <div style={{ display: 'flex', flexWrap: 'wrap', rowGap: 8, columnGap: 20 }}>
            {question.examples.map((example) => {
              const used = usedExamples.has(normalize(example));
              return (
                <SuggestionChip
                  key={example}
                  label={example}
                  used={used}
                  onClick={() => addEntry(example)}
                />
              );
            })}
          </div>
        </Stack>
      )}
    </Stack>
  );
}
